"use client"

import { Mail, Instagram, Linkedin } from "lucide-react"
import { AppLink } from "@/components/navigation/app-link"

import { SIGMAI_LOGO_SRC } from "@/lib/brand"

const LOGO_SRC = SIGMAI_LOGO_SRC

const socials = [
  { label: "Instagram", href: "https://www.instagram.com/sigmai_sports/", icon: Instagram },
  { label: "LinkedIn", href: "https://www.linkedin.com/company/sigmai-sports/", icon: Linkedin },
]

export function SiteFooter() {
  return (
    <footer className="bg-slate-900 text-white">
      <div className="container mx-auto max-w-6xl px-6 py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <AppLink href="/" className="inline-flex">
              <img
                src={LOGO_SRC}
                alt="SigmAI Sports Management"
                className="h-9 w-auto"
              />
            </AppLink>
            <p className="mt-4 max-w-md leading-relaxed text-slate-400">
              A football agency for professional players and their agents.
              We guide careers with trust, the right relationships, and clear
              data to back every decision.
            </p>
            <div className="mt-6 flex items-center gap-3">
              {socials.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-white/10 text-slate-200 transition-all duration-300 hover:bg-gradient-to-r hover:from-blue-600 hover:to-cyan-500 hover:text-white"
                  aria-label={social.label}
                >
                  <social.icon className="h-4 w-4" strokeWidth={1.75} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="mb-4 text-sm font-semibold uppercase tracking-wider text-slate-300">
              Explore
            </h4>
            <ul className="space-y-2 text-slate-400">
              <li>
                <AppLink href="/" className="transition-colors hover:text-white">
                  Home
                </AppLink>
              </li>
              <li>
                <AppLink href="/platform" className="transition-colors hover:text-white">
                  App
                </AppLink>
              </li>
              <li>
                <AppLink href="/players" className="transition-colors hover:text-white">
                  Players
                </AppLink>
              </li>
              <li>
                <AppLink href="/team" className="transition-colors hover:text-white">
                  Team
                </AppLink>
              </li>
            </ul>
          </div>

          <div id="contact" className="scroll-mt-24">
            <h4 className="mb-4 text-sm font-semibold uppercase tracking-wider text-slate-300">
              Get in touch
            </h4>
            <ul className="space-y-3 text-slate-400">
              <li>
                <AppLink href="/contact" className="transition-colors hover:text-white">
                  Contact form
                </AppLink>
              </li>
              <li>
                <a
                  href="mailto:info@sigmasportsmanagement.nl"
                  className="flex items-center gap-2 transition-colors hover:text-white"
                >
                  <Mail className="h-4 w-4" />
                  <span className="text-sm">info@sigmasportsmanagement.nl</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-8 md:flex-row">
          <p className="text-sm text-slate-400">
            © {new Date().getFullYear()} SigmAI. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-slate-400">
            <AppLink href="/privacy" className="transition-colors hover:text-white">
              Privacy
            </AppLink>
            <AppLink href="/terms" className="transition-colors hover:text-white">
              Terms
            </AppLink>
          </div>
        </div>
      </div>
    </footer>
  )
}
